module.exports = __webpack_public_path__ + "img/eight_.5d5eec0f.png";